import { gql } from "@apollo/client";

export const UPLOAD_LEADS = gql`
  mutation CreateLeads($campaignId: String!, $file: Upload!) {
    createLeads(campaignId: $campaignId, file: $file)
  }
`;

export const UPDATE_OUTBOND_FIELDS = gql`
  mutation UpdateOutboundFields(
    $outboundFieldsInput: UpdateOutboundFieldsInput!
  ) {
    updateOutboundFields(outboundFieldsInput: $outboundFieldsInput)
  }
`;

// "outboundFieldsInput": {
//     "campaignId": null,
//     "outboundFields": [
//       {
//         "fieldName": null,
//         "fieldValue": null
//       }
//     ]
//   }
export const DELETE_CAMPAIGN_LEADS = gql`
  mutation deleteCampaignLeads(
    $deleteCampaignLeadInput: DeleteCampaignLeadInput!
  ) {
    deleteCampaignLeads(deleteCampaignLeadInput: $deleteCampaignLeadInput) {
      email
      firstName
      lastName
      phone
    }
  }
`;
